import React, { createContext, useContext, useState } from "react";

const TabContext = createContext();

export const TabProvider = ({ children }) => {
  const [tabValue, setTabValue] = useState("details");
  return (
    <TabContext.Provider value={{ tabValue, setTabValue }}>
      {children}
    </TabContext.Provider>
  );
};

export const useTabContext = () => useContext(TabContext);
